import bootstrap from './js/index.js';
import './index.css';
bootstrap();


// WEBPACK FOOTER //
// ./src/index.js